import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M13 20l7 -7","key":"svg-0"}],["path",{"d":"M13 20v-6a1 1 0 0 1 1 -1h6v-7a2 2 0 0 0 -2 -2h-12a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7","key":"svg-1"}]]

/**
 * IconNote
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItbm90ZSIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTMgMjBsNyAtNyIgLz4KICA8cGF0aCBkPSJNMTMgMjB2LTZhMSAxIDAgMCAxIDEgLTFoNnYtN2EyIDIgMCAwIDAgLTIgLTJoLTEyYTIgMiAwIDAgMCAtMiAydjEyYTIgMiAwIDAgMCAyIDJoNyIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/note
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconNote = createReactComponent('outline', 'note', 'Note', __iconNode);

export default IconNote;